import de from '@translations/de/brandTabs.json';
import en from '@translations/en/brandTabs.json';
import pl from '@translations/pl/brandTabs.json';
import sl from '@translations/sl/brandTabs.json';
import uk from '@translations/uk/brandTabs.json';
import bg from '@translations/bg/brandTabs.json';
import cz from '@translations/cz/brandTabs.json';
import fr from '@translations/fr/brandTabs.json';
import gr from '@translations/gr/brandTabs.json';
import it from '@translations/it/brandTabs.json';
import pr from '@translations/pr/brandTabs.json';
import ru from '@translations/ru/brandTabs.json';
import sk from '@translations/sk/brandTabs.json';
import sp from '@translations/sp/brandTabs.json';
import tr from '@translations/tr/brandTabs.json';
import hu from '@translations/hu/brandTabs.json';
import { ITranslations } from '@/types/common';
import { BrandTabsTransFields } from './types';

export const brandTabsTranslations: ITranslations<BrandTabsTransFields> = {
  name: 'brandTabs',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
